"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarFontColorItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../button");

var _icons = require("../../icons");

var _popover = require("../../popover");

var _utils = require("../../utils");

var _helperComponents = require("../helperComponents");

var _constants = require("./constants");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["disabled", "editorInstance", "icon", "localization", "title"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ToolbarFontColorItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var disabled = _ref.disabled,
      editorInstance = _ref.editorInstance,
      IconComponent = _ref.icon,
      localization = _ref.localization,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var target = (0, _react.useRef)(null);
  var fontColorOptions = (0, _utils2.useFontColorOptions)(localization);

  var _useState = (0, _react.useState)(-1),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedOptionIndex = _useState2[0],
      setSelectedOptionIndex = _useState2[1];

  var labelTexts = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, _constants.toolbarFontColorPopoverDefaultProps.localization), localization);
  }, [localization]);
  var fontColorTitleText = labelTexts.fontColorTitleText;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isPopoverOpen = _useState4[0],
      setIsPopoverOpen = _useState4[1];

  var menuItemRefs = (0, _react.useRef)(new Map());
  var options = (0, _react.useMemo)(function () {
    return fontColorOptions;
  }, [fontColorOptions]);

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      highlightedOptionIndex = _useState6[0],
      setHighlightedOptionIndex = _useState6[1];

  var setMenuItemRef = (0, _react.useCallback)(function (index, node) {
    if (node) {
      menuItemRefs.current.set(index, node);
    } else {
      menuItemRefs.current.delete(index);
    }
  }, []);
  var focusPopoverMenuItemOnOpen = (0, _react.useCallback)(function () {
    if (highlightedOptionIndex === null && menuItemRefs.current.has(0)) {
      var menuItemRef = menuItemRefs.current.get(0);
      menuItemRef === null || menuItemRef === void 0 ? void 0 : menuItemRef.focus();
      var fontColor = '';
      var isCustomFont = editorInstance.isActive('textStyle', {
        class: _constants.FONT_COLOR_DEFAULT_CLASS_NAME
      });

      if (isCustomFont) {
        fontColor = editorInstance.getAttributes('textStyle').color;
      }

      var _selectedOptionIndex = (0, _utils2.findSelectedOptionIndex)(options, fontColor);

      setHighlightedOptionIndex(_selectedOptionIndex);
      setSelectedOptionIndex(_selectedOptionIndex);
    }
  }, [highlightedOptionIndex, options, editorInstance]);
  var handleMouseEnter = (0, _react.useCallback)(function (index) {
    setHighlightedOptionIndex(index);
  }, []);
  var handleMouseLeave = (0, _react.useCallback)(function () {
    setHighlightedOptionIndex(null);
  }, []);
  var changeHandler = (0, _react.useCallback)(function (option) {
    // apply color to the selected font
    editorInstance.commands.fontColor.set(option.value, option.title, labelTexts);
  }, [editorInstance, labelTexts]);
  var handleKeyDown = (0, _react.useCallback)(function (event) {
    var currentEnabledIndex = (0, _utils2.handlePopoverKeyboardNavigation)(event, options, setIsPopoverOpen, highlightedOptionIndex, setHighlightedOptionIndex, focusPopoverMenuItemOnOpen);

    switch (event.key) {
      case _utils.EventKeys.ENTER:
      case _utils.EventKeys.SPACEBAR:
        event.preventDefault();
        var currentOption = options[currentEnabledIndex];
        changeHandler(currentOption);
        break;
    }
  }, [changeHandler, highlightedOptionIndex, focusPopoverMenuItemOnOpen, options]);
  return (0, _core.jsx)(_react.Fragment, null, (0, _core.jsx)(_helperComponents.ToolbarButton, (0, _extends2.default)({
    ref: (0, _utils.mergeRefs)(target, ref),
    onClick: function onClick() {
      return setIsPopoverOpen(!isPopoverOpen);
    },
    disabled: disabled,
    icon: (0, _core.jsx)(IconComponent, {
      size: _icons.IconSize.Small,
      title: title
    }),
    variant: _button.ButtonVariant.Secondary,
    title: title,
    size: _button.ButtonSize.Small,
    "aria-expanded": isPopoverOpen,
    "aria-haspopup": "menu",
    "aria-label": title,
    tabIndex: -1
  }, rest)), (0, _core.jsx)("span", {
    hidden: true,
    id: "sroDialog"
  }, "has pop-up dialog"), (0, _core.jsx)(_popover.PopoverController, {
    "aria-haspopup": "menu",
    target: target,
    isOpen: isPopoverOpen,
    close: function close() {
      setIsPopoverOpen(false);
    },
    onOpened: function onOpened() {
      focusPopoverMenuItemOnOpen();
    },
    onClosed: function onClosed() {
      editorInstance.focus();
      setHighlightedOptionIndex(null);
    },
    shouldFocusOnOpen: true,
    position: _popover.PopoverPosition.BottomTrailing
  }, (0, _core.jsx)(_helperComponents.StyledPopoverList, {
    role: "menu",
    "aria-label": title,
    "aria-orientation": "vertical"
  }, (0, _core.jsx)(_helperComponents.StyledPopoverColorOptionTextContainer, {
    role: "note"
  }, fontColorTitleText), options.map(function (option, index) {
    return (0, _core.jsx)(_helperComponents.StyledColorItem, {
      ref: function ref(node) {
        return setMenuItemRef(index, node);
      },
      key: option.title,
      role: "menuitemradio",
      tabIndex: -1,
      isHighlighted: index === highlightedOptionIndex,
      isSelected: index === selectedOptionIndex,
      "aria-checked": index === selectedOptionIndex,
      onMouseEnter: function onMouseEnter() {
        return handleMouseEnter(index);
      },
      onMouseLeave: handleMouseLeave,
      onClick: function onClick() {
        return changeHandler(option);
      },
      onKeyDown: handleKeyDown
    }, (0, _core.jsx)(_helperComponents.StyledPopoverColorOptionContainer, null, (0, _core.jsx)(_helperComponents.StyledBadge, {
      "aria-hidden": "true",
      colorCode: option.value
    }), option.title));
  }))));
});
exports.ToolbarFontColorItem = ToolbarFontColorItem;